import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { PlanningPanelActions } from './planning-panel.actions';
import { PlanningPanelService } from '../../service/planning-panel-service';


@Injectable()
export class PlanningPanelEffects {

  loadPlanningPanel$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.loadPlanningPanel),
        mergeMap(({ typeOfAudit, year, parameters, fields }) =>
          rs.getLegalEntities(year, typeOfAudit, parameters).pipe(
            map((panel) => {
              return PlanningPanelActions.loadPlanningPanelSuccess({
                panel,
                fields
              });
            }),
            catchError((error) => of(PlanningPanelActions.loadPlanningPanelFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllPlanningPanel$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.loadAllPlanningPanel),
        mergeMap(({ typeOfAudit, year, parameters, fields }) =>
          rs.getLegalEntities(year, typeOfAudit, parameters).pipe(
            map((panel) => {
              return PlanningPanelActions.loadAllPlanningPanelSuccess({
                panel,
                fields
              });
            }),
            catchError((error) => of(PlanningPanelActions.loadAllPlanningPanelFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getTypeOfAudit$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.getTypeOfAudit),
        mergeMap(() =>
          rs.getTypeOfAudit().pipe(
            map((types) => {
              return PlanningPanelActions.getTypeOfAuditSuccess({
                types
              });
            }),
            catchError((error) => of(PlanningPanelActions.getTypeOfAuditFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getYears$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.getYears),
        mergeMap(() =>
          rs.getYears().pipe(
            map((years) => {
              return PlanningPanelActions.getYearsSuccess({
                years
              });
            }),
            catchError((error) => of(PlanningPanelActions.getYearsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getYearsRA$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.getYearsRA),
        mergeMap(() =>
          rs.getYearsRA().pipe(
            map((years) => {
              return PlanningPanelActions.getYearsRASuccess({
                years
              });
            }),
            catchError((error) => of(PlanningPanelActions.getYearsRAFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getPlanningDashboardCounters$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.getPlanningPanelCounters),
        mergeMap(({ typeOfAudit, year }) =>
          rs.getPlanningDashboardCounters(typeOfAudit, year).pipe(
            map((counters) => {
              return PlanningPanelActions.getPlanningPanelCountersSuccess({
                counters
              });
            }),
            catchError((error) => of(PlanningPanelActions.getPlanningPanelCountersFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getPlanningPanelFilters$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(PlanningPanelActions.getPlanningPanelFilters),
        mergeMap(({ year }) =>
          rs.getPlanningPanelFilters(year).pipe(
            map((filters) => {
              return PlanningPanelActions.getPlanningPanelFiltersSuccess({
                filters
              });
            }),
            catchError((error) => of(PlanningPanelActions.getPlanningPanelFiltersFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  constructor(private actions$: Actions) { }
}
